type Environment = 'local' | 'dev' | 'qat' | 'uat' | 'prd'

interface ServerConfig {
  digitalCommunicationsApiUrl: string
  settlementAssistantLoginUrl: string
  providerServicesApplicationId: number
  fedexUrl: string
  trustArcDomainIdentifier: string
  clarityProjectId?: string
  googleAnalyticsMeasurementId?: string
  customerServicePhoneNumber: string
  // Feature flag: when true, contact phone numbers/emails render as clickable tel:/mailto: links
  displayContactInfoAsLinks: boolean
}

const configs: Record<Environment, ServerConfig> = {
  local: {
    digitalCommunicationsApiUrl: 'https://localhost:7209',
    settlementAssistantLoginUrl: 'https://qa.settlementassistant.com/Login',
    providerServicesApplicationId: 1,
    fedexUrl: `https://www.fedex.com/wtrk/track/`,
    trustArcDomainIdentifier: 'npd-iaai.com',
    customerServicePhoneNumber: '(866) 698-4853',
    displayContactInfoAsLinks: true,
  },
  dev: {
    digitalCommunicationsApiUrl: 'https://qatapi-myvehicleclaim.iaai.com',
    settlementAssistantLoginUrl: 'https://dev.settlementassistant.com/Login',
    providerServicesApplicationId: 1,
    fedexUrl: `https://www.fedex.com/wtrk/track/`,
    trustArcDomainIdentifier: 'npd-iaai.com',
    customerServicePhoneNumber: '(866) 698-4853',
    displayContactInfoAsLinks: true,
  },
  qat: {
    digitalCommunicationsApiUrl: 'https://qatapi-myvehicleclaim.iaai.com',
    settlementAssistantLoginUrl: 'https://qa.settlementassistant.com/Login',
    providerServicesApplicationId: 1,
    fedexUrl: `https://www.fedex.com/wtrk/track/`,
    trustArcDomainIdentifier: 'npd-iaai.com',
    customerServicePhoneNumber: '(866) 698-4853',
    clarityProjectId: 'xo0hypy9wi',
    googleAnalyticsMeasurementId: 'G-N86CT3X920',
    displayContactInfoAsLinks: true,
  },
  uat: {
    digitalCommunicationsApiUrl: 'https://uatapi-myvehicleclaim.iaai.com',
    settlementAssistantLoginUrl: 'https://uat.settlementassistant.com/Login',
    providerServicesApplicationId: 1,
    fedexUrl: `https://www.fedex.com/wtrk/track/`,
    trustArcDomainIdentifier: 'npd-iaai.com',
    customerServicePhoneNumber: '(866) 698-4853',
    googleAnalyticsMeasurementId: 'G-S2R4TVDRY7',
    clarityProjectId: 'y1whlizazm',
    displayContactInfoAsLinks: true,
  },
  prd: {
    digitalCommunicationsApiUrl: 'https://api-myvehicleclaim.iaai.com',
    settlementAssistantLoginUrl: 'https://settlementassistant.com/Login',
    providerServicesApplicationId: 1,
    fedexUrl: `https://www.fedex.com/wtrk/track/`,
    trustArcDomainIdentifier: 'iaai.com',
    customerServicePhoneNumber: '(866) 698-4853',
    googleAnalyticsMeasurementId: 'G-BTK84DR8XE',
    clarityProjectId: 'yqfv29q9kz',
    displayContactInfoAsLinks: true,
  },
}

const getEnvironment = (): Environment => {
  const env = import.meta.env.VITE_ENV as Environment | undefined

  if (env && env in configs) {
    return env
  }

  // Default to local for development
  return 'local'
}

export const serverConfig = configs[getEnvironment()]
